import { ReactNode } from 'react';

import { Badge, BadgeType, Divider, IconItem } from '@scaleaq/scaleui';
import { DeviceStatus } from '@scaleaq/sitecontrol-lib';

import { GridWidget } from '@/components/GridWidget.tsx';
import { HeaderDivider } from '@/components/HeaderDivider.tsx';
import { Footer, StyledBody } from '@/components/sensorCard/sensorCard.styles.ts';
import { GenericWidgetProps } from '@/types.ts';

type SensorCardProps = GenericWidgetProps & {
  title: string;
  body: ReactNode;
  footer: ReactNode;
  connectionBadge?: { label: string; type: BadgeType };
  status?: DeviceStatus;
  isError?: boolean;
  isLoading?: boolean;

  toolbarActionList?: IconItem[];
  disabledToolbar?: boolean;
};
export const SensorCard = ({
  title,
  body: children,
  footer,
  connectionBadge,

  ...rest
}: SensorCardProps) => {
  return (
    <GridWidget {...rest} headerTitle={title}>
      <HeaderDivider />
      <StyledBody scaling={2}>{children}</StyledBody>
      <Divider color='soft_strong' />
      <Footer alignment='center-left' spaceBetween>
        {footer}{' '}
        {connectionBadge && <Badge {...connectionBadge} style={{ minWidth: '5.375rem' }} />}
      </Footer>
    </GridWidget>
  );
};
